import script from "./SidePanelHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./SidePanelHeader.vue?vue&type=script&setup=true&lang=js"

import "./SidePanelHeader.vue?vue&type=style&index=0&id=7b37ca8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b37ca8a"]])

export default __exports__